import { render } from "./cardActions.vue?vue&type=template&id=06517331&scoped=true"
import script from "./cardActions.vue?vue&type=script&lang=js"
export * from "./cardActions.vue?vue&type=script&lang=js"

import "./cardActions.vue?vue&type=style&index=0&id=06517331&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06517331"]])

export default __exports__